<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('myBusiness')">
        Minha Empresa
      </h1>
      <h1 class="title">
        <span class="pb-2" v-text="$ml.get('thisInformationCanAppear')"
          >Essas informações podem aparecer no perfil público da empresa, ao
          lado dos seus comentários e em qualquer um dos seus relatórios.</span
        >
      </h1>

      <div class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('publicInformation')">
            Dados Públicos
          </h6>
        </div>

        <div class="card-body">
          <form v-on:submit.prevent="">
            <div class="row">
              <div class="col pr-1">
                <div class="form-group">
                  <label class="text-muted" v-text="$ml.get('organizationName')"
                    >Nome da organização</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$ml.get('organizationName')"
                    v-model="name"
                    maxlength="250"
                  />
                  <transition name="fade">
                    <label
                      v-if="userError && !$v.name.required"
                      class="lblError"
                      v-text="$ml.get('enterTheNameOfTheOrganization')"
                      >Informe o nome da organização</label
                    >
                    <label
                      v-if="userError && !$v.name.regexOTN"
                      class="lblError"
                      v-text="$ml.get('nameIsNotValid')"
                      >O nome não é válido</label
                    >
                    <label
                      v-if="userError && !$v.name.minLength"
                      class="lblError"
                      v-text="
                        $ml
                          .with('f', 3)
                          .with('l', 40)
                          .get('theNameMustBeFromToCharacters')
                      "
                      >O nome deve de 3 a 40 caracteres</label
                    >
                  </transition>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label class="text-muted" v-text="$ml.get('executiveSummary')"
                    >Sumário executivo da organização</label
                  >
                  <textarea
                    v-model="about"
                    rows="3"
                    class="form-control"
                    maxlength="200"
                  >
                  </textarea>
                  <transition name="fade">
                    <label
                      v-if="userError && !$v.about.required"
                      class="lblError"
                      v-text="$ml.get('enterTheDescriptionOfTheOrganization')"
                      >Informe a descrição da organização</label
                    >
                    <label
                      v-if="userError && !$v.about.minLength"
                      class="lblError"
                      v-text="
                        $ml
                          .with('f', 3)
                          .with('l', 200)
                          .get('descriptionMustBeFromToCharacters')
                      "
                      >A descrição deve ter de 3 a 200 caracteres</label
                    >
                    <label
                      v-if="userError && !$v.about.restrictSpecialCharactersRegex"
                      class="lblError"
                      v-text="
                        $ml.get('descriptionCannotContainSpecialCharacters')
                      "
                      >A descrição não pode conter caracteres especiais</label
                    >
                  </transition>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col pr-1">
                <div class="form-group">
                  <label class="text-muted">Website</label>
                  <input
                    type="text"
                    v-model="website"
                    class="form-control"
                    placeholder="www.seusite.com"
                    maxlength="40"
                  />
                  <transition name="fade">
                    <label
                      v-if="userError && !$v.website.minLength"
                      class="lblError"
                      v-text="
                        $ml
                          .with('f', 3)
                          .with('l', 40)
                          .get('theWebsiteMustBeFromToCharacters')
                      "
                      >O website deve de 3 a 40 caracteres</label
                    >
                    <label
                      v-if="userError && !$v.website.regexURL"
                      class="lblError"
                      v-text="$ml.get('urlIsNotValid')"
                      >A url não é válida</label
                    >
                  </transition>
                </div>
              </div>
            </div>

            <div class="row pb-2">
              <div class="col pr-1">
                <div class="form-group">
                  <label class="text-muted" v-text="$ml.get('telephone')"
                    >Telefone</label
                  >
                  <the-mask
                    class="form-control"
                    v-model="phone"
                    :mask="['(##) ####-####', '(##) #####-####']"
                    placeholder="(99) 99999-9999"
                  />
                  <transition name="fade">
                    <label
                      v-if="userError && !$v.phone.required"
                      class="lblError"
                      v-text="$ml.get('enterTheCompletePhone')"
                      >Informe o Telefone completo</label
                    >
                    <label
                      v-if="userError && !$v.phone.minLength"
                      class="lblError"
                      v-text="$ml.get('enterTheCompletePhone')"
                      >Informe o Telefone completo</label
                    >
                  </transition>
                </div>
              </div>
            </div>
            <div class="row">
              <button @click="alterCompany()" class="btn m-0 px-4">
                <Spinner v-show="loadingBtn" />
                <span v-show="!loadingBtn" v-text="$ml.get('saveInformation')"
                  >Salvar</span
                >
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyService from "../../services/company.service";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import { utils } from "../../utils";


const regexOTN = utils.regexCheck("OTN");
const regexURL = utils.regexCheck("URL");
const restrictSpecialCharactersRegex = utils.regexCheck("restrictSpecialCharactersRegex");

export default {
  data() {
    return {
      name: "",
      nameSimile: "",
      website: "",
      about: "",
      phone: "",
      userError: false,
      loadingBtn: false,
    };
  },
  validations: {
    name: { required, regexOTN, minLength: minLength(3) },
    website: { regexURL, minLength: minLength(3) },
    about: { required, restrictSpecialCharactersRegex, minLength: minLength(3) },
    phone: { required, minLength: minLength(10) },
  },
  created() {
    this.changeCompany();
  },
  methods: {
    ...mapActions(["setUser"]),
    changeCompany() {
      CompanyService.getCompany().then((response) => {
        let resp = response.data;
        this.name = resp.name;
        this.nameSimile = resp.name;
        this.website = resp.website;
        this.about = resp.about;
        this.phone =
          String(resp.phone.areaCode) +
          (resp.phone.number ? resp.phone.number : "");
      });
    },
    alterCompany() {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.userError = true;
        this.loadingBtn = false;
        return;
      }

      this.loadingBtn = true;
      this.userError = false;
      this.tokerError = false;

      let payload = {
        about: this.about,
        website: this.website?.length ? this.website : "",
        phone: {
          countryCode: "55",
          areaCode: this.phone.substring(0, 2),
          number: this.phone.substring(2, 11),
        },
      };
   
      if (this.name != this.nameSimile) {
        payload.name = this.name;
      }

      var self = this;

      CompanyService.putCompany(payload).then(
        () => {
          this.setUser({
            companyName: this.name,
          });
          Swal.fire({
            icon: "success",
            title: self.$ml.get("dataChanged"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.loadingBtn = false;
          this.changeCompany();
        },
        (err) => {
          if (
            err.response.data.message[0] == "A url do website não é válida!"
          ) {
            Swal.fire({
              icon: "info",
              html: `<h4 class="mb-1">${self.$ml
                .with("website")
                .get("theIsNotValid")}</h4> 
            <label> 
            </label>  
            `,
              showConfirmButton: false,
              timer: 5000,
            });
          }

          this.loadingBtn = false;
        }
      );
    },
  },
};
</script>